import {
  AppBar,
  Container,
  ThemeProvider,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import { AppContext } from "../AppContext";
import useUserProfile from "../customhooks/useUserProfile";
import { ROUTES } from "../Routes";
import DesktopMenu from "./DesktopMenu";
import MobileMenu from "./MobileMenu";
import { headerTheme } from "./themes";

export default function AppHeader(props) {
  const appContext = React.useContext(AppContext);
  const isLoggedOn = appContext.authenticated === true;
  const id = useUserProfile();
  return (
    <ThemeProvider theme={headerTheme}>
      <div>
        <AppBar position="sticky">
          <Container maxWidth="md">
            <Toolbar style={{ paddingLeft: 0, marginBottom: "1vh" }}>
              <Typography variant="h3" style={{ flexGrow: 1 }}>
                <a
                  href={isLoggedOn ? ROUTES.AVAILABLE_JOBS : ROUTES.LOGIN}
                  style={{ textDecoration: "none" }}
                >
                  <span
                    style={{
                      color: "white",
                      fontFamily: "Montserrat",
                      fontWeight: "800",
                      fontDisplay: "swap",
                    }}
                  >
                    jo
                  </span>
                  <span
                    style={{
                      color: headerTheme.palette.text.secondary,
                      fontFamily: "Montserrat",
                      fontWeight: "800",
                      fontDisplay: "swap",
                    }}
                  >
                    joo
                  </span>
                </a>
              </Typography>
              <DesktopMenu isLoggedOn={isLoggedOn} id={id} />
              <MobileMenu isLoggedOn={isLoggedOn} id={id} />
            </Toolbar>
          </Container>
        </AppBar>
      </div>
    </ThemeProvider>
  );
}

/*   */
